import ResponsiveHeader from '@/components/ResponsiveHeader';
import { resolveHeaderBack } from '@/lib/navigation';
import { Stack } from 'expo-router';

/**
 * Downloads — own stack, sibling of `(home)`, like settings. Reached from the
 * drawer, the account screen and the offline banner; must render with no
 * network at all.
 */
export default function DownloadsStackLayout() {
  return (
    <Stack
      screenOptions={{
        animation: 'default',
        header: ({ navigation, options, back }) => {
          const { showBack, onBack } = resolveHeaderBack(navigation, back);
          return (
            <ResponsiveHeader
              title={(options.title as string) || ''}
              showBack={showBack}
              showBookmark={false}
              onBack={onBack}
              navItems={[
                { label: 'Explore', href: '/explore' },
                { label: 'Live', href: '/live' },
                { label: 'The Hang', href: '/library' },
              ]}
            />
          );
        },
      }}
    >
      <Stack.Screen name="index" options={{ title: 'My downloads' }} />
    </Stack>
  );
}
